/* unplugin-vue-components disabled */import script from "./level.vue?vue&type=script&setup=true&lang=js"
export * from "./level.vue?vue&type=script&setup=true&lang=js"

import "./level.vue?vue&type=style&index=0&id=26d5b85a&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d5b85a"]])

export default __exports__